var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/**
 * [CLAIMS_CONTEXT]
 * purpose: Manages the door lock damage description step in the break-in claim flow.
 * touches: break-in damage state/validation, door lock damage/type choices, damage description components.
 * invariants: lock-specific questions and their validation apply only when doorHasLockDamage is true; all updates/validation are scoped to the current changeKey.
 * inputs: damage changeKey, door lock damage state, lock damage/type choices, step configuration.
 * outputs: renders lock damage questions conditionally, updates damage state, exposes step validity, triggers validation/reveal or navigation.
 */
import { namespace } from 'vuex-class';
import Vue from 'vue';
import Component from 'vue-class-component';
import { UiIncremental } from '@claims-ia/design-system';
import BreakInDamageDescriptionSectionCard from '@declaration/components/breakInDamage/DamageDescription/UI/BreakInDamageDescriptionSectionCard.vue';
import BreakInDamageDescriptionStep from '@declaration/components/breakInDamage/DamageDescription/UI/BreakInDamageDescriptionStep.vue';
import RadioPrimaryButton from '@declaration/components/UI/RadioPrimaryButton.vue';
import { YES_OR_NO_CHOICES } from '@declaration/helpers/choices';
import BreakInDamageDescriptionSubSection from '@declaration/components/breakInDamage/DamageDescription/UI/BreakInDamageDescriptionSubSection.vue';
import { parseLength } from '@declaration/helpers/typeFormatters';
import { DOOR_LOCK_DAMAGES, DOOR_LOCK_TYPE_TRAD_KEYS_AND_IMAGES, } from '@shared/constants/breakInDamages/DoorConstants';
import BreakInDamageChoices from '@declaration/components/breakInDamage/DamageDescription/UI/BreakInDamageChoices.vue';
const layout = namespace('layout');
const breakInDamage = namespace('breakInDamage');
let DoorLockDamage = class DoorLockDamage extends Vue {
    constructor() {
        super(...arguments);
        this.parseLength = parseLength;
        this.showValidation = false;
        this.YES_OR_NO_CHOICES = YES_OR_NO_CHOICES;
        this.DOOR_LOCK_DAMAGES = DOOR_LOCK_DAMAGES;
        this.doorLockTypes = Object.entries(DOOR_LOCK_TYPE_TRAD_KEYS_AND_IMAGES).map(([doorLockType, description]) => ({
            value: doorLockType,
            tradKey: description.tradKey,
            image: description.image,
        }));
    }
    get change() {
        return this.changeGetter(this.changeKey);
    }
    get breakInDamage() {
        return this.change.data;
    }
    get validation() {
        return this.validationGetter(this.changeKey);
    }
    get isValid() {
        let validation = !this.validation.fieldHasViolations('doorHasLockDamage');
        if (this.breakInDamage.doorHasLockDamage) {
            validation =
                validation &&
                    !this.validation.fieldHasViolations('doorLockType') &&
                    !this.validation.fieldHasViolations('doorLockDamage');
        }
        return validation;
    }
    update(data) {
        this.updateBreakInDamage({ changeKey: this.changeKey, data });
    }
    save() {
        this.$emit('goToNextStep');
    }
    revealValidation() {
        this.$store.dispatch('error/add', this.$tc('error.form.please_validate_message'));
        this.validateBreakInDamage(this.changeKey);
        this.showValidation = true;
    }
    get displayLockQuestions() {
        return this.breakInDamage.doorHasLockDamage;
    }
};
__decorate([
    layout.State('color')
], DoorLockDamage.prototype, "color", void 0);
__decorate([
    breakInDamage.Getter('change')
], DoorLockDamage.prototype, "changeGetter", void 0);
__decorate([
    breakInDamage.Action('updateDamage')
], DoorLockDamage.prototype, "updateBreakInDamage", void 0);
__decorate([
    breakInDamage.Getter('validation')
], DoorLockDamage.prototype, "validationGetter", void 0);
__decorate([
    breakInDamage.Action('validateAndRevealDamages')
], DoorLockDamage.prototype, "validateBreakInDamage", void 0);
DoorLockDamage = __decorate([
    Component({
        components: {
            UiIncremental,
            BreakInDamageDescriptionStep,
            BreakInDamageDescriptionSectionCard,
            RadioPrimaryButton,
            BreakInDamageChoices,
            BreakInDamageDescriptionSubSection,
        },
        props: {
            changeKey: { type: [String, Number], default: null },
            isFinalStep: { type: Boolean, default: false },
            isSaving: { type: Boolean, default: false },
        },
    })
], DoorLockDamage);
export default DoorLockDamage;
